var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header"
  }, [_c('preloader'), _c('div', {
    staticClass: "header__content row"
  }, [_c('div', {
    staticClass: "menu-button-container"
  }, [_c('a', {
    staticClass: "menu-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showMenu($event);
      }
    }
  })]), _c('div', {
    staticClass: "auth-container"
  }, [_vm.user === null ? _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": "/login"
    }
  }) : [this.$route.name === 'profile' ? _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.showLogoutModal($event);
      }
    }
  }) : _c('router-link', {
    staticClass: "user-pic",
    attrs: {
      "to": "/profile"
    }
  })]], 2), _c('div', {
    staticClass: "header__logo"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeSiteMenu($event);
      }
    }
  }, [_vm._v(_vm._s(_vm.$config.site.title))])], 1), this.$route.meta.layout === 'index' ? _c('nav', {
    staticClass: "header__nav-wrap"
  }, [_c('ul', {
    staticClass: "header__nav"
  }, [_c('li', {
    staticClass: "current"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Новые возможности ваших финансов.")])], 1)])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }